import React from "react";
import { observer } from "mobx-react";
import { Button, Modal } from "react-bootstrap";

import { useAppStore } from "../../providers/AppStoreProvider";
import { useAPI } from "../../providers/ApiProvider";

export const AddToCartModal = observer(() => {
  const store = useAppStore();
  const api = useAPI();

  const reportSubmitHandler = () => {};

  return (
    <Modal size="md" show={store.addToCartModal.show} onHide={store.addToCartModal.toggle}>
      <Modal.Header closeButton className="border-0">
        <Modal.Title as="h3" className="fw-bold">
          Mở khoá trải nghiệm
        </Modal.Title>
      </Modal.Header>

      <Modal.Body></Modal.Body>

      <Modal.Footer className="border-0">
        <Button
          className="fw-bold rounded-pill bg-gradient-orange border-0 w-100 py-3 px-4"
          onClick={reportSubmitHandler}
        >
          <span>Thêm vào giỏ hàng</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
